import { baseRequest as thirdBaseRequest, downLoadFile } from './thirdBase'
import { baseRequest, baseRequest2 } from './base'

// 获取推送消息
function getPushMessage(params) {
  return thirdBaseRequest(`/qyweixin/getPushMessage`, 'get', params);
}
// 进群助手时获取班级信息
function groupInspection(params) {
  return thirdBaseRequest(`/qyweixin/groupChatClassInspection`, 'get', params);
}
// 重新绑定班级群
function bindClassChat(params) {
  return thirdBaseRequest(`/qyweixin/bindClassChat`, 'get', params);
}
// 群消息推送成功，保存日志
function pushMessageLog(key,params) {
  return baseRequest(`/api/pcWeb/teaSchedule/insertSchedulePushMsgLog/${key}`, 'post', params);
}
// 保存二维码
function downloadChatQrcode(params) {
  return downLoadFile(`/qyweixin/downloadChatQrcode`, 'get', params);
}
// 获取今日课节数
function getTodayCount(params) {
  return thirdBaseRequest(`/qyweixin/getTodayChatOverview`, 'get', params);
}
// 获取通知数据
function getNoticeInfo(scheduleId,key,params) {
  return baseRequest(`/api/pcWeb/teaSchedule/redirctAppMiniProgram/${scheduleId}/${key}`, 'get', params);
}
// 获取通知数据
function getSignature(id,params) {
  return baseRequest(`/api/pcWeb/teaParent/jsapi/${id}`, 'get', params);
}
// 保存群二维码
function saveQrcode(params) {
  return thirdBaseRequest(`/qyweixin/updateGroupChatQrcode`, 'post', params);
}
// 群不存在时，删除该群聊
function deleteClassChatGroup(params) {
  return thirdBaseRequest(`/qyweixin/deleteClassChatGroup`, 'post', params);
}
// 获取每日更新群二维码的群ID
function getUpdateGroupIds(params) {
  return thirdBaseRequest(`/qyweixin/refreshGroupQR`, 'get', params);
}

export default {
  groupInspection,
  bindClassChat,
  getPushMessage,
  pushMessageLog,
  downloadChatQrcode,
  getTodayCount,
  getNoticeInfo,
  getSignature,
  saveQrcode,
  deleteClassChatGroup,
  getUpdateGroupIds,
}